module.exports = __webpack_public_path__ + "img/icon_h5link@2x.ee405fb5.png";